import 'whatwg-fetch';
import Constants from '../model/AppConfiguration';
import StatusCodes from '../model/StatusCodes';
// import convert from 'xml-js';

export default { getSessionToken: getSessionToken };

function getSessionToken () {
  let loginData = {
    Uname: 'Josip',
    Pword: 'josip123',
    SaveInfo: 'yes',
    UTCOffset: -60,
    fuseaction: 'login.validate',
  };
  let formData = createFormData(loginData);
  return new Promise(resolve => resolve({ status: 0 }));
  // return fetch(`${Constants.BASE_URL}?${formData}`, {
  //   method: 'POST',
  //   mode: 'cors',
  //   credentials: 'include',
  //   headers: {
  //     Accept:
  //       'application/x-www-form-urlencoded;multipart/form-data;application/json;text/plain;text/html;text/xml',
  //     'Content-Type':
  //       'application/x-www-form-urlencoded;multipart/form-data;application/json;text/plain;text/html;text/xml',
  //   },
  // })
  //   .then(response =>
  //     response
  //       .text()
  //       .then(response => {
  //         if (response.error || response.status === StatusCodes.UNKNOWN_ERROR) {
  //           return responseError(response);
  //         }

  //         // let responseData = convert.xml2json(response, { compact: true, spaces: 4 });
  //         // , data: JSON.parse(responseData)
  //         return { status: 0 };
  //       })
  //       .catch(error => responseError(error))
  //   )
  //   .catch(error => responseError(error));
}

function responseError (response) {
  return {
    status: response.code || StatusCodes.UNKNOWN_ERROR,
    data: null,
    message: response.message || 'Error',
  };
}

function createFormData (object) {
  let formData = '';

  for (let key in object) {
    formData += `${key}=${object[ key ]}&`;
  }

  if (formData && formData[ formData.length - 1 ] === '&') {
    formData = formData.slice(0, formData.length - 1);
  }

  return formData;
}



// WEBPACK FOOTER //
// ./src/remoting/DevAuthRemoting.js